import styled from "styled-components";

export const FlexContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    /* width: 100%; */
    height: 100vh;
    
`;
export const LoginContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 600px;
    height: auto;
    margin: auto;
    margin-top: -20px;
    box-shadow: 0px 2px 16px 1px rgba(0,0,0,0.2);
    padding: 50px 60px;
    border-radius: 10px;
    align-self: center;
    img{
        width: 200px;
        align-self: center;
    }
    p{
        text-align: center;
    }
   
    @media only screen and (max-width: 992px) {
        /* padding: 50px 10px; */
        width: 100%;
    }
`;